import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import DeliveriesRoute from 'cio/routes/base-deliveries';
import TransactionalMessageModel from 'cio/models/transactional-message';
import TransactionalMessageOverviewDraftsController from 'cio/pods/transactional/message/overview/drafts/controller';
import Transition from '@ember/routing/-private/transition';

export default class TransactionalMessageOverviewDraftsRoute extends DeliveriesRoute {
  @service features!: FeaturesService;

  setupController(
    controller: TransactionalMessageOverviewDraftsController,
    model: TransactionalMessageModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    controller.set('campaign', `transactional_${model.id}`);
    controller.fetchDeliveries.perform();
  }
}
